<template>
  <transition name="modalbg">
    <div @click.self="closeModal" class="modal_container">
      <transition name="modal" v-on:before-leave="modalClose">
        <div v-if="showed" class="modal">
          <div class="caption">
            <div class="title-modal">{{textContent.titleAdd}}</div>
            <div @click="closeModal" class="close"></div>
          </div>
          <div class="modal-scroll" :class="{ 'in-last-tab' : isLastTab }">
            <div class="modal-content">
              <form v-on:submit.prevent="addItem">
                <form-input name="title"></form-input>
                <form-input name="seo_title"></form-input>
                <form-file use-case="seo" name="img"></form-file>
                <form-input name="seo_alt"></form-input>
                <form-text-area name="seo_key"></form-text-area>
                <form-text-area name="seo_desc"></form-text-area>
              </form>
            </div>
          </div>
          <div class="buttons">
            <div class="next">
              <button @click="closeModal" class="cancel">{{textContent.cancelButton}}</button>
              <button class="confirm" @click="onAddItem">{{textContent.submitButton}}</button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
  import IconAlignleft from '@/components/icons/IconAlignleft'
  import IconSignalbars from '@/components/icons/IconSignalbars'
  import IconArrowbold from '@/components/icons/IconArrowbold'
  import FormInput from '@/components/create-form/Input'
  import FormTextArea from '@/components/create-form/TextArea'
  import FormFile from '@/components/create-form/File'
  import FormDropDown from '@/components/create-form/DropDown'
  import FormTextEditor from '@/components/create-form/TextEditor'
  import {createNamespacedHelpers} from 'vuex'
  import Tabs from '@/components/create-form/Tabs'

  const {mapMutations, mapActions, mapState, mapGetters} = createNamespacedHelpers('mainPage')

  export default {
    data () {
      return {
        showed: false,
      }
    },
    computed: {
      ...mapState([
        'textContent',
        'fields'
      ]),
      ...mapGetters([
        'getDataFromEditor',
        'isLastTab'
      ]),
      apiUrls () {
        return this.$store.state.apiUrls
      }
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev',
        'checkTabAwailability',
        'translit'
      ]),
      ...mapMutations([
        'setField',
        'resetTextEditor',
        'setTabs',
        'setCurrentTabId',
        'setFileExtensions'
      ]),
      onAddItem () {
        this.addItem()
      },
      closeModal () {
        this.showed = false
      }
    },
    mounted () {
      this.showed = true
    },
    created () {
      this.setCurrentTabId(0)
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Название категории',
          errorId: null,
          errors: {empty: 'Введите название категории'},
          tabId: 0
        },
        seo_title: {
          value: '',
          parameterName: 'seo_title',
          name: 'Название страницы',
          errorId: null,
          errors: {empty: 'Напишите название страницы'},
          tabId: 1
        },
        seo_alt: {
          value: '',
          parameterName: 'seo_alt',
          name: 'Alt',
          errorId: null,
          errors: {empty: 'Напишите alt для картинки'},
          tabId: 0,
          isNullable: true
        },
        seo_key: {
          value: '',
          parameterName: 'seo_key',
          name: 'Ключевые слова',
          errorId: null,
          errors: {empty: 'Напишите ключевые слова'},
          tabId: 0
        },
        seo_desc: {
          value: '',
          parameterName: 'seo_desc',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Напишите краткое описание'},
          tabId: 0
        },
        img: {
          value: '',
          parameterName: 'img',
          name: 'Изображение',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 0
        },
      })
    },
    components: {
      IconAlignleft,
      IconSignalbars,
      IconArrowbold,
      FormInput,
      FormTextArea,
      FormFile,
      FormDropDown,
      FormTextEditor,
      Tabs
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/blog/categories/CreateModal.vue